<style scoped>
.this__icon {
  position: absolute;
  top: 20px;
  right: 16px;
}
</style>
<template>
  <notifications group="loggedIn" position="bottom right">
    <template slot="body" slot-scope="props">
      <div class="notification-content demo__relative" :class="props.item.type">
        <div class="notification-title" v-if="props.item.title">
          <div class="iconTitle">
            <img
              v-if="props.item.data && getIcon(props.item.data.icon)"
              :src="getIcon(props.item.data.icon)"
              alt="Notification Icon"
              class="notification-icon"
            />
            <p>{{ props.item.title }}</p>
          </div>
        </div>
        <div class="notification-text" v-html="props.item.text"></div>
        <i
          class="fa-light fa-xmark-large this__icon"
          @click="props.close"
          width="16px"
        ></i>
      </div>
    </template>
  </notifications>
</template>

<script>
export default {
  data() {
    return {
      icons: {
        error: require("@/assets/images/notifyIcons/error.svg"),
      },
    };
  },
  created() {
    this.$accessModule("noty", this);
  },
  methods: {
    getIcon(type) {
      if (!type || !this.icons[type]) {
        return null;
      }
      return this.icons[type];
    },
  },
};
</script>
